module.exports = __webpack_public_path__ + "media/images/royalslider/grabbing-b231b62df6ad72b806a6ceb1e31af46f.png";